
  import { ref, computed, defineComponent } from 'vue';
  import { Icon } from '@/ui/components/icon/Icon';
  import { InputField } from '@/ui/components/form';
  import { Button } from '@/ui/components/Button';
  import Spinner from '@/ui/components/Spinner.vue';

  export interface PaginationProps {
    current: number;
    perPage: number;
    total: number;
    totalLoading?: boolean;
  }

  const firstPageNumber = 1;

  export default defineComponent<PaginationProps>({
    name: 'StaticPagination',
    components: {
      Icon,
      Button,
      Spinner,
      InputField,
    },
    props: ['current', 'perPage', 'total', 'totalLoading'],
    setup(props, context) {
      const pageCount = computed(() => Math.ceil(props.total / props.perPage));
      const pageNumber = ref(props.current);

      const isButtonDisabled = computed(() =>
        pageNumber.value === props.current || pageNumber.value > pageCount.value || pageNumber.value < firstPageNumber);

      const onChangePage = () => {
        context.emit('page-changed', pageNumber.value);
      };

      const onInputChangePage = () => {
        if (!isButtonDisabled.value) {
          onChangePage();
        }
      };

      const onInputFieldChange = (value: string) => {
        pageNumber.value = Number(value);
      };

      const handleChangePage = (value: number) => {
        pageNumber.value = value;
        onChangePage();
      };

      return {
        pageCount,
        pageNumber,
        isButtonDisabled,
        handleChangePage,
        onInputChangePage,
        onInputFieldChange,
      };
    },
  });
